import CONSTANTS from "./constants";
import BaseHttpHandler from "./utilities/baseHttpHandler";

// Gets all locations
async function getAllLocations() {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.get(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.LOCATION,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

// Creates a new location
// expects an object, something like this:
/* {
  code: "49",
  description: "sharon new 1",
  phoneNumber: "456123",
  activeFrom: "",
  activeTo: "",
  announceTransferToCaller: false,
  beepBeforeConnecting: false,
  callAnswerAction: 2,
  secondsBeforeDivert: 20,
  announceIntendedRecipient: false,
  announceIntendedRecipientStatus: false,    
};*/
async function createNewLocation(location) {
  const locationData = {
    code: location.code,
    description: location.description,
    phoneNumber: location.phoneNumber,
    activeFrom: "",
    activeTo: "",
    announceTransferToCaller: false,
    beepBeforeConnecting: false,
    callAnswerAction: 2,
    secondsBeforeDivert: 20,
    announceIntendedRecipient: false,
    announceIntendedRecipientStatus: false
  }
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.post(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.LOCATION,
      locationData,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

async function editLocation(location) {
  const locationData = {
    code: location.code,
    description: location.description,
    phoneNumber: location.phoneNumber,
  }
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.put(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.LOCATION + "/" + location.code,
      locationData,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

async function deleteLocation(location) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.delete(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.LOCATION + "/" + location.code,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

async function setLocationCode(locationCode) {
  try {
    let instance = await BaseHttpHandler.getInstance();

    const response = await instance.put(
      CONSTANTS.API_CONSTANTS.ENDPOINTS.SET_LOCATION_CODE + locationCode,
      {
        cancelToken: BaseHttpHandler.getTimedCancelToken().token,
      }
    );

    return response.data;
  } catch (e) {
    // If the endpoint returns anything other a 200 response okay message we need to know about it and handle it appropriately
    console.log(e);
    throw e;
  }
}

export default {
  getAllLocations,
  setLocationCode,
  createNewLocation,
  editLocation,
  deleteLocation,
};
